/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NuovoOtpDto } from '../../models/nuovo-otp-dto';

export interface ApiOtpGeneraOtpGet$Params {}

export function apiOtpGeneraOtpGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiOtpGeneraOtpGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<NuovoOtpDto>> {
    const rb = new RequestBuilder(rootUrl, apiOtpGeneraOtpGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<NuovoOtpDto>;
        }),
    );
}

apiOtpGeneraOtpGet.PATH = '/api/otp/genera-otp';
